<template>
  <div class="step-page">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "StepPage",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.step-page {
  padding: 20px;
  @include mq-down(md) {
    margin-right: -20px;
    margin-left: -20px;
  }
  @include mq-up(md) {
    border-radius: 10px;
  }
  &.-success {
    background-color: $success;
  }
}
</style>
